import { Component, Inject } from '@angular/core';
import { SIDE_EFFECT_DATA_TOKEN, SideEffectData } from './models/types';

@Component({
    selector: 'side-effect-change-well-owner',
    templateUrl: './side-effect-change-well-owner.component.html',
    standalone: false
})
export class SideEffectChangeWellOwnerComponent {
    _seConfiguration: any;

    set seConfiguration(value: any) {
        this._seConfiguration = value || {};
        this._seConfiguration.WellDispositionUponTransfer = this._seConfiguration.WellDispositionUponTransfer || '';
        this._seConfiguration.WellDispositionLegacyTrackingUponTransfer = this._seConfiguration.WellDispositionLegacyTrackingUponTransfer || '';
        this._seConfiguration.WellTypeDescriptionUponTransfer = this._seConfiguration.WellTypeDescriptionUponTransfer || '';
        this._seConfiguration.OrganizationId = this._seConfiguration.OrganizationId || '';
        this._seConfiguration.WellsToTransferContextPath = this._seConfiguration.WellsToTransferContextPath || '';
        this._seConfiguration.TargetContextObjectIsArrayOfWells = this._seConfiguration.TargetContextObjectIsArrayOfWells || false;
        this._seConfiguration.ReleaseOfLeaseProvided = this._seConfiguration.ReleaseOfLeaseProvided || false;
        this._seConfiguration.WithoutFiveAcres = this._seConfiguration.WithoutFiveAcres || false;
        this._seConfiguration.UpdateGISOwnerAttributes = this._seConfiguration.UpdateGISOwnerAttributes || false;
        this._seConfiguration.AlwaysUpdateLegacyTracking = this._seConfiguration.AlwaysUpdateLegacyTracking || false;
        this._seConfiguration.AlwaysUpdateDisposition = this._seConfiguration.AlwaysUpdateDisposition || false;
        this._seConfiguration.AlwaysUpdateTypeDescription = this._seConfiguration.AlwaysUpdateTypeDescription || false;
    }

    get seConfiguration(): any {
        return this._seConfiguration;
    }

    constructor(@Inject(SIDE_EFFECT_DATA_TOKEN) data: SideEffectData) {
        this.seConfiguration = data.configuration;
    }
}
